import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, getPreferredLanguage, LANGUAGE_STORAGE_KEY, normalizeLanguage,  } from './language';
import { SHIPPING_CALCULATOR_I18N_RESOURCES, SHIPPING_CALCULATOR_NAMESPACE,  } from './templates/shippingCalculator';
import { PRODUCT_LIBRARY_I18N_RESOURCES, PRODUCT_LIBRARY_NAMESPACE,  } from './templates/productLibrary';
import { ADDRESS_BOOK_I18N_RESOURCES, ADDRESS_BOOK_NAMESPACE,  } from './templates/addressBook';
import { ACCOUNT_I18N_RESOURCES, ACCOUNT_NAMESPACE,  } from './templates/account';
import { USER_PROFILE_I18N_RESOURCES, USER_PROFILE_NAMESPACE,  } from './templates/userProfile';
import { ABOUT_I18N_RESOURCES, ABOUT_NAMESPACE,  } from './templates/about';
import { DROPSHIPPING_GUIDE_I18N_RESOURCES, DROPSHIPPING_GUIDE_NAMESPACE,  } from './templates/dropshippingGuide';
import { LABELING_I18N_RESOURCES, LABELING_NAMESPACE,  } from './templates/labeling';
import { LABELING_ORDER_FLOW_I18N_RESOURCES, LABELING_ORDER_FLOW_NAMESPACE,  } from './templates/labelingOrderFlow';
import { LABELING_SINGLE_ORDER_I18N_RESOURCES, LABELING_SINGLE_ORDER_NAMESPACE,  } from './templates/labelingSingleOrder';
import { LABELING_BATCH_ORDER_I18N_RESOURCES, LABELING_BATCH_ORDER_NAMESPACE,  } from './templates/labelingBatchOrder';
import { LABELING_POST_ORDER_I18N_RESOURCES, LABELING_POST_ORDER_NAMESPACE,  } from './templates/labelingPostOrder';
import { ORDER_I18N_RESOURCES, ORDER_NAMESPACE,  } from './templates/order';

const resources = {
  zh: {
    [SHIPPING_CALCULATOR_NAMESPACE]: SHIPPING_CALCULATOR_I18N_RESOURCES.zh,
    [PRODUCT_LIBRARY_NAMESPACE]: PRODUCT_LIBRARY_I18N_RESOURCES.zh,
    [ADDRESS_BOOK_NAMESPACE]: ADDRESS_BOOK_I18N_RESOURCES.zh,
    [ACCOUNT_NAMESPACE]: ACCOUNT_I18N_RESOURCES.zh,
    [USER_PROFILE_NAMESPACE]: USER_PROFILE_I18N_RESOURCES.zh,
    [ABOUT_NAMESPACE]: ABOUT_I18N_RESOURCES.zh,
    [DROPSHIPPING_GUIDE_NAMESPACE]: DROPSHIPPING_GUIDE_I18N_RESOURCES.zh,
    [LABELING_NAMESPACE]: LABELING_I18N_RESOURCES.zh,
    [LABELING_ORDER_FLOW_NAMESPACE]: LABELING_ORDER_FLOW_I18N_RESOURCES.zh,
    [LABELING_SINGLE_ORDER_NAMESPACE]: LABELING_SINGLE_ORDER_I18N_RESOURCES.zh,
    [LABELING_BATCH_ORDER_NAMESPACE]: LABELING_BATCH_ORDER_I18N_RESOURCES.zh,
    [LABELING_POST_ORDER_NAMESPACE]: LABELING_POST_ORDER_I18N_RESOURCES.zh,
    [ORDER_NAMESPACE]: ORDER_I18N_RESOURCES.zh,
  },
  en: {
    [SHIPPING_CALCULATOR_NAMESPACE]: SHIPPING_CALCULATOR_I18N_RESOURCES.en,
    [PRODUCT_LIBRARY_NAMESPACE]: PRODUCT_LIBRARY_I18N_RESOURCES.en,
    [ADDRESS_BOOK_NAMESPACE]: ADDRESS_BOOK_I18N_RESOURCES.en,
    [ACCOUNT_NAMESPACE]: ACCOUNT_I18N_RESOURCES.en,
    [USER_PROFILE_NAMESPACE]: USER_PROFILE_I18N_RESOURCES.en,
    [ABOUT_NAMESPACE]: ABOUT_I18N_RESOURCES.en,
    [DROPSHIPPING_GUIDE_NAMESPACE]: DROPSHIPPING_GUIDE_I18N_RESOURCES.en,
    [LABELING_NAMESPACE]: LABELING_I18N_RESOURCES.en,
    [LABELING_ORDER_FLOW_NAMESPACE]: LABELING_ORDER_FLOW_I18N_RESOURCES.en,
    [LABELING_SINGLE_ORDER_NAMESPACE]: LABELING_SINGLE_ORDER_I18N_RESOURCES.en,
    [LABELING_BATCH_ORDER_NAMESPACE]: LABELING_BATCH_ORDER_I18N_RESOURCES.en,
    [LABELING_POST_ORDER_NAMESPACE]: LABELING_POST_ORDER_I18N_RESOURCES.en,
    [ORDER_NAMESPACE]: ORDER_I18N_RESOURCES.en,
  },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: getPreferredLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: ['zh', 'en'],
    defaultNS: SHIPPING_CALCULATOR_NAMESPACE,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    returnEmptyString: false,
  });
}

i18n.on('languageChanged', (value) => {
  if (typeof window === 'undefined') return;
  const language = normalizeLanguage(value);
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
});

export default i18n;
